import { CoreStore } from "Stores/RESTStore/CoreStore";
import { observable, action, runInAction, makeObservable } from "mobx";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { sortBy } from "lodash";
export class FilePrintStore extends CoreStore {
  data: API_PrintJobFile[];
  plotProviders: API_PrintJobProvider[] = [];
  usedForDisitibutionMatrix: boolean = false;
  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      plotProviders: observable,
      clear: action.bound,
      init: action.bound,
      getGroupMembers: action.bound,
      getPlotProviders: action.bound,
      normalizeFiles: action.bound,
    });
  }

  url() {
    return "";
  }

  clear() {
    this.data = [];
    this.plotProviders = [];
  }

  /**
   * Use this function to open Print modal with predefined files
   * @param files - Array of FileDataEntity objects
   */
  init(files: API_FileDataEntity[]) {
    this.data = this.normalizeFiles(files);
  }

  // NOTE: modal shall be called from showModal feature
  // initModalFromDistributionMatrix(printJob: API_PrintJob) {
  //   this.data = printJob.files;
  //   this.usedForDisitibutionMatrix = true;
  // }

  async getGroupMembers(groupId: number) {
    try {
      return await API.getData(API_URL.GROUPS.getGroupMembers(projectsDataStore.projectId, groupId));
    } catch (error) {
      throw error;
    }
  }

  async getPlotProviders() {
    try {
      let response = await API.getData<API_PrintJobProvider[]>(
        API_URL.PROVIDER.getProjectProviders(projectsDataStore.projectId),
        { printJob: true }
      );
      response = sortBy(response, ["priority"]);
      const cdsIndex = response.findIndex((item) => item.id === 0);
      if (cdsIndex !== -1) {
        response.push(response[cdsIndex]);
        response.splice(cdsIndex, 1);
      }
      runInAction(() => {
        this.plotProviders = response;
      });
    } catch (error) {
      throw error;
    }
  }

  normalizeFiles(files: API_FileDataEntity[]): API_PrintJobFile[] {
    return files.map((file: API_FileDataEntity & API_FileInfo) => ({
      name: file.name ? file.name : file.fileName,
      id: file.id,
      copies: 1,
      folding: null,
      plotter: null,
      scale: 100,
    }));
  }
}

export const filePrintStore = new FilePrintStore();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).filePrint = filePrintStore;
